<h2 mat-dialog-title>{{ 'home.contact_us' | translate }}</h2>
<mat-dialog-content class="mat-typography">
  <p>
    {{ 'home.need_help' | translate }}
  </p>
</mat-dialog-content>
<div class="flex justify-end p-4">
  <pl-button class="!w-fit" [mat-dialog-close]="true" [padding]="ButtonPadding.small">
    {{ 'utils.close' | translate }}
  </pl-button>
</div>
